// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"33bfaf5c","540":"b52811b5","601":"d1bfc9e8","701":"aabda8d5","904":"ba819b6f"}[chunkId] + ".chunk.js";
};